import React from 'react'
import { FormattedMessage } from 'react-intl'
import { isEmpty } from 'lodash'
import { selectCurrentMarketMetadata } from 'src/store/selectors/marketRecord'
import { selectHomeValue } from 'src/store/selectors/home/metadata'
import { useSelector } from 'react-redux'
import Format from 'src/Components/shared/Format'
import SectionWrapper from 'src/Components/shared/SectionWrapper'
import Text from 'src/Components/shared/Text'
import { Unless } from 'src/Components/shared/Conditionals/Conditionals'

import baseStyles from '../MarketSpotlight.module.scss'
import styles from './MarketFacts.module.scss'

const NumberWrapper = props => (
  <Text
    size='l'
    element='div'
    className={styles.wrapper__item__number}
    {...props}
  />
)

const Label = props => <Text size='xs' element='div' color='quiet' {...props} />

const MarketFacts = () => {
  const homeValue = useSelector(selectHomeValue)
  const metadata = useSelector(selectCurrentMarketMetadata)
  const { quartile = {} } = metadata
  const { bedsMean, bathsMean, sqftMedian } = quartile

  return (
    <Unless condition={isEmpty(quartile)}>
      <SectionWrapper
        className={baseStyles.section}
        data-qa='market-facts-section'
      >
        <Text
          element='h4'
          size='l'
          align='center'
          paragraph
          className={styles.text}
        >
          <FormattedMessage
            id='ZipCodeDetail.heading.marketHomeAttrs'
            defaultMessage='Homes valued around {avmValue} tend to have:'
            values={{
              avmValue: (
                <Text element='span' color='pink'>
                  <Format.Currency abbreviate value={homeValue} />
                </Text>
              )
            }}
          />
        </Text>
        <div className={styles.wrapper}>
          <div
            data-qa='market-facts-beds-mean'
            className={styles.wrapper__item}
          >
            <NumberWrapper>
              <Format.Number value={bedsMean} format='0.0' />
            </NumberWrapper>
            <Label>
              <FormattedMessage
                id='ZipCodeDetail.label.bedrooms'
                defaultMessage='Bedrooms'
              />
            </Label>
          </div>
          <div
            data-qa='market-facts-baths-mean'
            className={styles.wrapper__item}
          >
            <NumberWrapper>
              <Format.Number value={bathsMean} format='0.0' />
            </NumberWrapper>
            <Label>
              <FormattedMessage
                id='ZipCodeDetail.label.avgBaths'
                defaultMessage='Bathrooms'
              />
            </Label>
          </div>
          <div
            data-qa='market-facts-sqft-median'
            className={styles.wrapper__item}
          >
            <NumberWrapper>
              <Format.Number value={sqftMedian} format='0,0' />
            </NumberWrapper>
            <Label>
              <FormattedMessage
                id='ZipCodeDetail.label.avgSqft'
                defaultMessage='Sqft'
              />
            </Label>
          </div>
        </div>
      </SectionWrapper>
    </Unless>
  )
}

export default MarketFacts
